import {
  UPDATE_PROJECT_ACTIVITY_REQUEST,
  UPDATE_PROJECT_ACTIVITY_ERROR,
  UPDATE_PROJECT_ACTIVITY_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/updateEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (entity, entityTableData) => (state = initialState, action) => {

  context.init(context);

  context.UPDATE_ENTITY_REQUEST = UPDATE_PROJECT_ACTIVITY_REQUEST;
  context.UPDATE_ENTITY_ERROR = UPDATE_PROJECT_ACTIVITY_ERROR;
  context.UPDATE_ENTITY_SUCCESS = UPDATE_PROJECT_ACTIVITY_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projectActivity";
  context.entityLocation = RESOURCES.ProjectActivities;

  return context.execute(context)(entity, entityTableData)(state, action);
};